import React from 'react';

import NoResults from 'components/NoResults/NoResults';

import NO_RESULTS from 'assets/no-results.svg';

import styles from 'components/ErrorScreens/NotAssignedError.scss';

const NotAssignedError = () => {
  return (
    <NoResults
      className={styles.notAssigned}
      icon={NO_RESULTS}
      subTitle={`Oops! It appears you don't have permission to access this application.`}
      content={'Please email Arrive Edge Support for more information or to request access.'}
      actionContent={<a href={'mailto:helpdesk@arrivelogistics.com'}>Email Arrive Edge Support</a>}
    />
  )
};

export default NotAssignedError;
